export default "__VITE_ASSET___tHMQJq1__"